import { useMediaQuery } from '@chakra-ui/react'
import clsx from 'clsx'
import ApplyV2Picture from '@core/components/ApplyDialogV2/ApplyV2Picture'
import type { ApplyV2SettingsSectionName, GetApplyV2SettingsResponse } from '@core/app/types/applyV2Type'
import ApplySkeleton from '@core/components/ApplyDialogV2/ApplySkeleton'
import ApplyV2CvStep from '@core/components/ApplyDialogV2/ApplyV2CvStep'
import ApplyV2ProfileStep from '@core/components/ApplyDialogV2/ApplyV2ProfileStep'
import React, { type FC, useMemo, RefObject } from 'react'
import bgSize from '../assets/apply_v2_bg_size.jpg'
import bg1 from '../assets/apply_v2_bg.jpg'
import bg2 from '../assets/apply_v2_bg_x2.jpg'
import bgSizeWebp from '../assets/apply_v2_bg_size.webp'
import bg1Webp from '../assets/apply_v2_bg.webp'
import bg2Webp from '../assets/apply_v2_bg_x2.webp'
import bgSizeAvif from '../assets/apply_v2_bg_size.avif'
import bg1Avif from '../assets/apply_v2_bg.avif'
import bg2Avif from '../assets/apply_v2_bg_x2.avif'
import './ApplyV2Content.scss'

const baseClass = 'ApplyV2Content'

interface ApplyV2ContentProps {
    className?: string
    navItems: {
        name: ApplyV2SettingsSectionName
        visible: boolean
        required: boolean
        order: number
    }[]
    // activeIndex: number
    currentStep: ApplyV2SettingsSectionName | null
    sliderRef: RefObject<HTMLDivElement>
    isExpanded: boolean
    isLoading: boolean
    settingsData: GetApplyV2SettingsResponse | null | undefined
}

const ApplyV2Content: FC<ApplyV2ContentProps> = ({
    className = '',
    navItems,
    currentStep,
    sliderRef,
    isExpanded,
    isLoading,
    settingsData,
}) => {
    const [isDesktop] = useMediaQuery('(min-width: 1230px)')

    const isBgImageOrColor = settingsData?.appearance?.image || settingsData?.appearance?.color

    const stepValues = useMemo(() => {
        const activeIndex = navItems.findIndex((item) => item.name === currentStep)
        return `${activeIndex + 1}/${navItems.length}`
    }, [navItems, currentStep])

    if (!isExpanded) {
        return (
            <div
                className={clsx(className, baseClass, {
                    [`${baseClass}--expanded`]: isExpanded,
                    [`${baseClass}--desktop`]: isDesktop,
                })}
            ></div>
        )
    }

    return (
        <div
            className={clsx(className, baseClass, {
                [`${baseClass}--expanded`]: isExpanded,
                [`${baseClass}--desktop`]: isDesktop,
                [`${baseClass}--desktop_no-image`]: isDesktop && !isBgImageOrColor,
            })}
        >
            <div className={`${baseClass}__slider-wrapper`} ref={sliderRef}>
                {navItems.map((item, index) => (
                    <div key={item.name} className={`${baseClass}__slide`}>
                    <ApplySkeleton isLoading={isLoading}>
                            <div className="ApplyV2Content__step"> Step: {stepValues}</div>
                        </ApplySkeleton>
                        <ApplySkeleton isLoading={isLoading}>
                            <div className="ApplyV2Content__step-name">
                                {item.name && item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                            </div>
                        </ApplySkeleton>
                        {item.name === 'cv' && <ApplyV2CvStep currentStep={currentStep} navItems={navItems} />}
                        {item.name === 'profile' && <ApplyV2ProfileStep />}
                    </div>
                ))}
            </div>
            {isDesktop && settingsData?.appearance?.image && (
                <ApplyV2Picture
                    // className="apply-picture"
                    imgClassName="apply-picture-img"
                    // imgSrcSet={`${bg1} 1x, ${bg2} 2x`}
                    // sources={[
                    //     {
                    //         srcSet: bg2Avif,
                    //         type: 'image/avif',
                    //         media: '(min-width: 1024px)',
                    //     },
                    //     {
                    //         srcSet: bg1Avif,
                    //         type: 'image/avif',
                    //         media: '(min-width: 768px) and (max-width: 1023px)',
                    //     },
                    //     {
                    //         srcSet: bgSizeAvif,
                    //         type: 'image/avif',
                    //         media: '(max-width: 767px)',
                    //     },
                    //     {
                    //         srcSet: `${bg2Webp}`,
                    //         type: 'image/webp',
                    //         media: '(min-width: 1024px)',
                    //     },
                    //     {
                    //         srcSet: `${bg1Webp}`,
                    //         type: 'image/webp',
                    //         media: '(min-width: 768px) and (max-width: 1023px)',
                    //     },
                    //     {
                    //         srcSet: `${bgSizeWebp}`,
                    //         type: 'image/webp',
                    //         media: '(max-width: 767px)',
                    //     },
                    //     {
                    //         srcSet: `${bg2}`,
                    //         type: 'image/jpeg',
                    //         media: '(min-width: 1024px)',
                    //     },
                    //     {
                    //         srcSet: `${bg1}`,
                    //         type: 'image/jpeg',
                    //         media: '(min-width: 768px) and (max-width: 1023px)',
                    //     },
                    //     {
                    //         srcSet: `${bgSize}`,
                    //         type: 'image/jpeg',
                    //         media: '(max-width: 767px)',
                    //     },
                    // ]}
                    loading="lazy"
                    fallbackSrc={settingsData.appearance.image}
                    alt={'apply bg'}
                />
            )}
        </div>
    )
}

export default ApplyV2Content
